import { useQuery } from "@tanstack/react-query";
import { getContentBlock, type ContentBlockRow } from "@/services/content.service";

/**
 * Reads a content block by key. Returns null while loading or if missing,
 * so consumers can fall back to defaults seamlessly.
 */
export function useContentBlock(key: string) {
  const { data, isLoading } = useQuery<ContentBlockRow | null>({
    queryKey: ["content-block", key],
    queryFn: () => getContentBlock(key),
    staleTime: 60_000,
  });
  return { block: data ?? null, isLoading };
}
